"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, var(--smar--com--color--blue--100,#9ebbff))",
  d: "M2.936 13.36c0-3.034 1.177-4.479 3.14-5.494l1.962 2.585-1.686 2.91zm3.139-5.656c3.14-2.689 5.748-1.073 7.85-.393l-1.963 3.533-3.924-.393z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m6.664 7.267 1.963 3.062-1.179.755-1.962-3.061zm4.709 3.062 1.962-3.062 1.179.756-1.962 3.061z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 7.05c-3.339 0-6.1 2.48-6.539 5.697a.14.14 0 0 0 .043.125c.04.043.11.078.196.078h1.823a.37.37 0 0 0 .248-.112.87.87 0 0 0 .23-.379c.506-1.648 2.037-2.865 3.858-2.865 1.82 0 3.351 1.217 3.857 2.865a.87.87 0 0 0 .23.38.37.37 0 0 0 .249.11H16.3a.27.27 0 0 0 .196-.077.14.14 0 0 0 .043-.125 6.6 6.6 0 0 0-6.54-5.697m-7.926 5.508a8.002 8.002 0 0 1 15.852 0c.14 1.031-.717 1.792-1.626 1.792h-2.105c-.972 0-1.602-.78-1.817-1.48a2.65 2.65 0 0 0-2.52-1.876c-1.179 0-2.185.79-2.519 1.876-.215.7-.845 1.48-1.816 1.48H3.7c-.91 0-1.767-.76-1.626-1.792",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 7.789a.7.7 0 0 0-.7.7v5.102a.7.7 0 1 0 1.4 0V8.489a.7.7 0 0 0-.7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MeterTwoIcon20.js.map